'use strict';

angular.module('webAgro1App').factory('RelatorioFechamentoService', function($http) {
  return {
    gerar: function(params) {
      return $http.post(`${SERVER}v1/relatorio_fechamento_safra`, {
        propriedade: params.propriedade.id,
        safra: params.safra.id,
        glebas: params.glebas.map((gleba) => gleba.id),
        timeline: !!params.timeline,
        atividade: params.atividade.id,
        exibir_fotos: !!params.exibir_fotos,
        exibir_anotacoes: !!params.exibir_anotacoes
      }).then((result) => result);
    },

    download: function(params) {
      return $http.get(`${SERVER}v1/relatorio_fechamento_safra/${params.job_id}`)
        .then((result) => result);
    }
  };
});
